import { render, staticRenderFns } from "./veStuAssocChargeShow.vue?vue&type=template&id=8941f794&scoped=true"
import script from "./veStuAssocChargeShow.vue?vue&type=script&lang=js"
export * from "./veStuAssocChargeShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8941f794",
  null
  
)

export default component.exports